var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{attrs:{"variant":_vm.secondaryVariant},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.httpRequest.apply(null, arguments)}}},[_vm._v(" Pcap Fetch ")])}
var staticRenderFns = []

export { render, staticRenderFns }